/* ============================================================================
   Ancona Fine Jewelry — Enhancement JS (ancona-enhance.js)
   Vanilla, dependency-free, progressive enhancement. Load with `defer`.
   Loaded globally via theme.liquid (Ancona Pass 25/H3: the sticky-ATC snippet's
   duplicate tag is deleted; the double-execution guard stays for safety).
   Everything is feature-guarded: if the target markup isn't present, nothing runs.
   No third-party scripts. KPI hooks fire ONLY if window.dataLayer already exists.
   Ancona Pass 25 (G6): the dead initCarousel + initZoom features (no liquid ever
   rendered .ancona-carousel or [data-ancona-zoom]) are deleted, along with the
   now-unused reduceMotion flag — restore from theme history to revert.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__anconaEnhance) return; // double-execution guard
  window.__anconaEnhance = true;

  /* ---- KPI hook (non-invasive): only pushes if a dataLayer already exists --- */
  function track(event, payload) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: 'ancona:' + event }, payload || {}));
    }
    // Also dispatch a DOM event so any existing listener can subscribe without a dataLayer.
    document.dispatchEvent(new CustomEvent('ancona:' + event, { detail: payload || {} }));
  }

  /* Ancona Pass 25 (G6): initCarousel (formerly feature 1) and initZoom (formerly
     feature 3) deleted — dead code shipping inaccessible patterns (10px dots,
     keyboardless zoom) for markup no liquid emits. Restore from theme history. */

  /* ---- 2) Sticky mobile add-to-cart ----------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('.ancona-sticky-atc');
    if (!bar) return;
    // The real form's submit button on the PDP (Craft/Dawn):
    var realBtn = document.querySelector('product-form button[name="add"], #ProductSubmitButton-' + (bar.getAttribute('data-section') || ''));
    var anchor = document.querySelector(bar.getAttribute('data-watch') || 'product-form');
    var proxyBtn = bar.querySelector('.ancona-sticky-atc__btn');

    if (proxyBtn && realBtn) {
      proxyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        /* Ancona Pass 25 (A1): guard the proxy — when the real button (or the
           mirrored proxy) is disabled the click is a no-op, so neither the
           theme click nor the KPI event fires. Remove the guard to revert. */
        if (realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true' || proxyBtn.disabled) return;
        realBtn.click();               // reuse the theme's own AJAX add-to-cart + drawer
        track('sticky_add_to_cart', { source: 'sticky_bar' });
      });
    }
    /* Ancona Pass 25 (A1): aria-hidden + inert travel with data-visible, so the
       off-screen bar is never keyboard-focusable or screen-reader-exposed
       (the CSS hidden state additionally carries visibility:hidden for the
       pre-JS window). Remove setVisible + restore plain setAttribute to revert. */
    function setVisible(on) {
      bar.setAttribute('data-visible', on ? 'true' : 'false');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      try { bar.inert = !on; } catch (err) { /* inert unsupported: visibility:hidden still guards */ }
    }
    if (!anchor || !('IntersectionObserver' in window)) { setVisible(true); return; }
    setVisible(false);
    var io = new IntersectionObserver(function (entries) {
      // Show the sticky bar only when the real add-to-cart is scrolled out of view.
      setVisible(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(anchor);
  }

  /* ---- 4) Lightweight CTA / discovery KPI hooks (guarded) ------------------- */
  function initKpiHooks() {
    /* ONE delegated listener instead of per-element bindings: elements inside
       Dawn's cart drawer are re-rendered (innerHTML replaced) on every cart
       mutation, which silently dropped their per-element hooks. Delegation
       survives any re-render; makeLink-created chips carry data-ancona-hooked
       (they track themselves) so they can never double-fire. */
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ancona-cta]:not([data-ancona-hooked])') : null;
      if (el) track('cta_click', { label: el.getAttribute('data-ancona-cta') || el.textContent.trim().slice(0, 40) });
    });
  }

  /* ---- 5) Safe search suggestions + recovery states ------------------------- */
  /* Pure /search?q= links and existing collections only — no invented
     collections, no claims. Styled by .ancona-search-suggest rules in
     ancona-polish.css and .ancona-chip rules in ancona-enhance.css.
     Every destination below was verified live on the storefront. */
  var SUGGEST_LINKS = [
    ['Chains', '/search?q=chains&type=product'],
    ['Tennis', '/search?q=tennis&type=product'],
    ['Bridal', '/search?q=bridal&type=product'],
    ['Gold Essentials', '/search?q=gold&type=product'],
    ['Gifts', '/search?q=gift&type=product'],
    ['Earrings', '/search?q=earrings&type=product'],
    ['Pendants', '/search?q=pendant&type=product'],
    ['Diamond', '/search?q=diamond&type=product']
  ];
  var RECOVERY_LINKS = [
    ['Chains', '/collections/chains'],
    ['Gifts', '/search?q=gift&type=product'],
    ['Diamonds', '/collections/diamond-jewelry'],
    ['Gold', '/collections/gold-jewelry'],
    ['Earrings', '/collections/earrings'],
    ['Pendants', '/collections/charms-pendants'],
    ['Bridal', '/search?q=bridal&type=product'],
    ['Tennis', '/search?q=tennis&type=product']
  ];
  /* ancona-enhance.css is loaded per-section (ancona sections / PDP snippets),
     NOT globally — collection pages have none of them. Any injector that uses
     enhance.css classes must call this first. Idempotent. */
  function ensureEnhanceCss() {
    if (document.querySelector('link[href*="ancona-enhance.css"]')) return;
    var selfTag = document.querySelector('script[src*="ancona-enhance.js"]');
    if (selfTag && selfTag.getAttribute('src')) {
      var lnk = document.createElement('link');
      lnk.rel = 'stylesheet';
      lnk.href = selfTag.getAttribute('src').split('?')[0].replace('ancona-enhance.js', 'ancona-enhance.css');
      document.head.appendChild(lnk);
    }
  }
  function makeLink(labelText, href, cta, className) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = labelText;
    if (className) a.className = className;
    a.setAttribute('data-ancona-cta', cta + ':' + labelText);
    a.setAttribute('data-ancona-hooked', 'true'); /* skip in initKpiHooks — listener attached here */
    a.addEventListener('click', function () {
      track('cta_click', { label: cta + ':' + labelText });
    });
    return a;
  }
  function initSearchSuggest() {
    /* Inject into the header search modal AND the /search page form (a single
       querySelector used to reach only the hidden header modal). On the /search
       page the chips render ONLY on the no-query landing and the zero-results
       state — populated result pages stay untouched (no layout shift, no
       clutter). Dawn adds .template-search--empty for BOTH "no query yet" and
       "searched, found nothing", so the recovery note additionally requires a
       real q parameter. */
    var forms = document.querySelectorAll('.search-modal predictive-search form, details-modal predictive-search form, predictive-search form, main-search form');
    var hasQuery = false;
    try { hasQuery = !!(window.URLSearchParams && new URLSearchParams(location.search).get('q')); } catch (e) {}
    var isEmptyState = !!document.querySelector('.template-search--empty');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.querySelector('.ancona-search-suggest')) return;
      var onSearchPage = !!(form.closest && form.closest('main-search'));
      if (onSearchPage && !isEmptyState) return; /* results are showing — stay out of the way */
      var field = form.querySelector('.field');
      if (!field) return;
      var wrap = document.createElement('div');
      wrap.className = 'ancona-search-suggest';
      if (isEmptyState && hasQuery && onSearchPage) {
        var note = document.createElement('p');
        note.className = 'ancona-search-suggest__note';
        note.textContent = 'No exact match yet — try a simpler term or explore our main shopping paths.';
        wrap.appendChild(note);
      }
      var label = document.createElement('span');
      label.className = 'ancona-search-suggest__label';
      label.textContent = 'Quick searches';
      wrap.appendChild(label);
      SUGGEST_LINKS.forEach(function (s) {
        wrap.appendChild(makeLink(s[0], s[1], 'search-suggest'));
      });
      field.insertAdjacentElement('afterend', wrap);
    });
  }

  /* ---- 5b) Collection no-results recovery ------------------------------------ */
  /* When merchant-configured filters produce an empty result, Dawn renders
     .collection--empty inside #ProductGridContainer (and re-renders that
     container on every facet change). Add safe recovery paths under the
     theme's own "use fewer filters" message. Links are verified existing
     collections/searches only — nothing is invented. */
  function initCollectionRecovery() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    function inject() {
      var empty = container.querySelector('.collection--empty');
      if (!empty || empty.querySelector('.ancona-recovery')) return;
      ensureEnhanceCss();
      var box = document.createElement('div');
      box.className = 'ancona-enhance ancona-recovery';
      var msg = document.createElement('p');
      msg.className = 'ancona-recovery__msg';
      msg.textContent = 'No exact match yet — clear filters or explore Chains, Gifts, Diamonds, and Gold.';
      box.appendChild(msg);
      var row = document.createElement('ul');
      row.className = 'ancona-recovery__row';
      row.setAttribute('role', 'list');
      row.setAttribute('aria-label', 'More ways to shop');
      RECOVERY_LINKS.forEach(function (s) {
        var li = document.createElement('li');
        li.appendChild(makeLink(s[0], s[1], 'collection-recovery', 'ancona-chip'));
        row.appendChild(li);
      });
      box.appendChild(row);
      empty.appendChild(box);
    }
    inject();
    /* Dawn's facets.js swaps the container's DIRECT children on every filter
       re-render — childList alone catches that; subtree would fire on every
       grid card mutation for nothing. Stays connected for the page's life. */
    if ('MutationObserver' in window) {
      new MutationObserver(inject).observe(container, { childList: true });
    }
  }

  /* ---- 5c) PDP recommendations graceful fallback ------------------------------ */
  /* Ancona Pass 25 (A12): deterministic empty-state detection. Dawn's
     <product-recommendations> SKIPS the DOM write entirely when the fetched
     section has no inner content (global.js ~:1151), so the old observer-only
     fallback could never fire in exactly the empty case it existed for. Now:
     fetch the SAME URL Dawn builds (data-url + product_id + section_id), parse
     it detached with DOMParser (no resource loads, no script execution), and
     inject the "Explore more" row only when that render truly contains no
     .grid__item. The MutationObserver stays as the success-path short-circuit —
     if Dawn lands real cards first we disconnect and never inject. On any
     network/HTTP failure the state is unknown and nothing is injected. Scoped
     to the related-products element only (never the complementary block, which
     Dawn removes itself when empty). Restore the observer-only version to revert. */
  function initRecsFallback() {
    var el = document.querySelector('product-recommendations.related-products') ||
             document.querySelector('product-recommendations:not(.complementary-products)');
    if (!el) return;
    var done = false;
    var mo = null;
    function finish() { done = true; if (mo) { mo.disconnect(); mo = null; } }
    function injectFallback() {
      if (done) return;
      finish();
      if (el.querySelector('.grid__item') || el.querySelector('.ancona-explore')) return;
      ensureEnhanceCss();
      var box = document.createElement('div');
      box.className = 'ancona-enhance ancona-explore';
      var h = document.createElement('h2');
      h.className = 'ancona-explore__title';
      h.textContent = 'Explore more from Ancona';
      box.appendChild(h);
      var row = document.createElement('ul');
      row.className = 'ancona-recovery__row';
      row.setAttribute('role', 'list');
      [
        ['Shop Chains', '/collections/chains'],
        ['Shop Gifts', '/search?q=gift&type=product'],
        ['Explore Diamonds', '/collections/diamond-jewelry'],
        ['Under $500', '/collections/under-500']
      ].forEach(function (s) {
        var li = document.createElement('li');
        li.appendChild(makeLink(s[0], s[1], 'pdp-explore', 'ancona-chip'));
        row.appendChild(li);
      });
      box.appendChild(row);
      el.appendChild(box);
      track('recs_fallback_shown');
    }
    /* Success short-circuit: Dawn rendered real recommendation cards. */
    if ('MutationObserver' in window) {
      mo = new MutationObserver(function () {
        if (done) return;
        if (el.querySelector('.grid__item')) finish();
      });
      mo.observe(el, { childList: true });
    }
    var baseUrl = el.getAttribute('data-url') || '';
    var productId = el.getAttribute('data-product-id') || '';
    var sectionId = el.getAttribute('data-section-id') || '';
    if (!baseUrl || !productId || !sectionId) return;
    if (typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return;
    window.fetch(baseUrl + '&product_id=' + encodeURIComponent(productId) + '&section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (done) return;
        if (el.querySelector('.grid__item')) { finish(); return; }
        if (!text) return; /* HTTP failure: unknown state — never inject */
        var doc = new DOMParser().parseFromString(text, 'text/html');
        if (doc.querySelector('.grid__item')) { finish(); return; } /* Dawn will render these */
        injectFallback();
      })
      .catch(function () { /* network failure: unknown state — never inject */ });
  }

  /* ---- 6) Recently viewed (strictly browser-local; nothing is sent anywhere) */
  /* Stores {u:url, t:title, p:price, i:image, ts:when} for the last 8 PDPs in
     localStorage and shows up to 4 (excluding the current product) above
     Related Products. Entries expire after 30 days (also bounds price
     staleness — the price shown is the one this shopper saw). Images are
     normalized to 600px CDN thumbnails and only same-origin/Shopify-CDN URLs
     are ever rendered. All nodes are built with createElement/textContent
     (no HTML injection); the strip is user-clearable with focus + status
     handling and is labeled as saved only in this browser. Styled by the
     .ancona-recent* rules in ancona-enhance.css (loaded on the PDP by the
     ancona snippets; a <link> fallback is injected here if absent). */
  function initRecentlyViewed() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var productPrefix = root + 'products/';
    if (location.pathname.indexOf(productPrefix) !== 0) return;
    var KEY = 'ancona:recently-viewed';
    var TTL = 30 * 24 * 60 * 60 * 1000; /* 30 days */
    var now = Date.now();
    function read() {
      try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
    }
    function thumb(u) {
      if (typeof u !== 'string' || !u) return '';
      var sameOrigin = u.charAt(0) === '/' && u.charAt(1) !== '/';
      var shopCdn = u.indexOf('https://') === 0 && (u.indexOf('/cdn/shop/') !== -1 || u.indexOf('cdn.shopify.com') !== -1);
      if (!sameOrigin && !shopCdn) return '';
      if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=600');
      return u + (u.indexOf('?') === -1 ? '?width=600' : '&width=600');
    }

    /* Sequential lookups = real priority order (a comma list is document-order).
       No bare-h1 fallback: skipping the entry beats storing a wrong title. */
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__info-container h1');
    var priceEl = document.querySelector('.product__info-container .price__regular .price-item--regular') ||
                  document.querySelector('.product__info-container .price-item--regular');
    var imgEl = document.querySelector('.product__media img');
    if (titleEl) {
      var entry = {
        u: location.pathname,
        t: titleEl.textContent.replace(/\s+/g, ' ').trim().slice(0, 80),
        p: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim().slice(0, 24) : '',
        i: thumb(imgEl ? (imgEl.currentSrc || imgEl.src || '') : ''),
        ts: now
      };
      var list = read().filter(function (x) { return x && x.u !== entry.u; });
      list.unshift(entry);
      write(list);
    }

    var items = read().filter(function (x) {
      return x && typeof x.u === 'string' && x.u.indexOf(productPrefix) === 0 && x.u !== location.pathname &&
        typeof x.ts === 'number' && (now - x.ts) < TTL &&
        (x.t === undefined || typeof x.t === 'string') &&
        (x.p === undefined || typeof x.p === 'string') &&
        (x.i === undefined || typeof x.i === 'string');
    }).slice(0, 4);
    if (!items.length) return;

    /* Stylesheet fallback: normally loaded by the ancona PDP snippets. */
    ensureEnhanceCss();

    var host = document.createElement('section');
    host.className = 'ancona-enhance ancona-recent';
    host.setAttribute('aria-label', 'Recently viewed');
    var inner = document.createElement('div');
    inner.className = 'ancona-container';
    var head = document.createElement('div');
    head.className = 'ancona-recent__head';
    var title = document.createElement('h2');
    title.className = 'ancona-recent__title';
    title.textContent = 'Recently viewed';
    var note = document.createElement('span');
    note.className = 'ancona-recent__note';
    note.textContent = 'Saved only in this browser';
    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'ancona-recent__clear';
    clearBtn.textContent = 'Clear';
    clearBtn.setAttribute('aria-label', 'Clear recently viewed items');
    clearBtn.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      /* Keep focus + announce the result instead of yanking the section away. */
      while (inner.firstChild) inner.removeChild(inner.firstChild);
      var status = document.createElement('p');
      status.className = 'ancona-recent__status';
      status.setAttribute('role', 'status');
      status.textContent = 'Recently viewed items cleared.';
      inner.appendChild(status);
      host.setAttribute('tabindex', '-1');
      host.focus();
      track('recently_viewed_clear');
    });
    head.appendChild(title); head.appendChild(note); head.appendChild(clearBtn);

    var grid = document.createElement('ul');
    grid.className = 'ancona-recent__grid';
    grid.setAttribute('role', 'list');
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'ancona-recent__card';
      var a = document.createElement('a');
      a.href = it.u;
      a.setAttribute('data-ancona-cta', 'recently-viewed:' + it.u);
      var imgSrc = thumb(it.i || '');
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = ''; /* decorative — the title span names the link */
        img.loading = 'lazy'; img.decoding = 'async';
        img.width = 300; img.height = 300;
        img.onerror = function () { if (img.parentNode) img.parentNode.removeChild(img); };
        a.appendChild(img);
      }
      var t = document.createElement('span'); t.className = 'ancona-recent__t'; t.textContent = it.t || ''; a.appendChild(t);
      if (it.p) { var p = document.createElement('span'); p.className = 'ancona-recent__p'; p.textContent = it.p; a.appendChild(p); }
      li.appendChild(a); grid.appendChild(li);
    });

    inner.appendChild(head); inner.appendChild(grid); host.appendChild(inner);
    var rel = document.querySelector('.related-products');
    var anchorSection = rel ? (rel.closest ? rel.closest('.shopify-section') : null) : null;
    if (anchorSection && anchorSection.parentNode) anchorSection.parentNode.insertBefore(host, anchorSection);
    else { var main = document.getElementById('MainContent'); if (main) main.appendChild(host); }
  }

  /* ---- 7) True-italic face flag (Ancona Pass 25: J6 support) ----------------- */
  /* The craftsmanship folio numerals only go italic when a TRUE italic face for
     the heading serif is registered (the J2 font_face in theme.liquid) — a
     synthesized oblique would undercut the point. Flags <html> with
     .ancona-italic-face; the paired rule lives at the end of ancona-enhance.css.
     Remove this block + that rule to revert (numerals fall back to upright). */
  function initItalicFaceFlag() {
    try {
      if (!document.fonts || typeof document.fonts.forEach !== 'function') return;
      function check() {
        var found = false;
        document.fonts.forEach(function (f) {
          if (found) return;
          var fam = String(f.family || '').replace(/["']/g, '');
          if (/playfair/i.test(fam) && /italic|oblique/i.test(String(f.style || ''))) found = true;
        });
        if (found) document.documentElement.classList.add('ancona-italic-face');
        return found;
      }
      if (!check() && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(function () { check(); }).catch(function () {});
      }
    } catch (e) { /* decorative only — never break the page */ }
  }

  function boot() {
    initStickyAtc();
    initRecentlyViewed();
    initSearchSuggest();
    initCollectionRecovery();
    initRecsFallback();
    initItalicFaceFlag();
    initKpiHooks(); /* last, so injected [data-ancona-cta] elements get hooks */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
